
import { Vue, Component, Watch, Inject } from "vue-property-decorator";
import DContainerLayout from "@/views/base/DContainerLayout.vue";
import { isEmpty, showConfirm, showError, showSuccess, showWarning } from "@/utils/Common";
import { MSG_INVALID_PAGE } from "@/configs/Consts";
import DList from "@/views/base/DList.vue";
import { API_PATENT_MANUALADD, API_PATENT_MANUALQUERY, API_PATENT_PATENTEE_SETTING } from "@/configs/Apis";

@Component({
  components: { DList, DContainerLayout }
})
export default class AddPatent extends Vue {
  queryStr: string = "";
  showGrid: boolean = false;
  selectedCount: number = 0;

  progrssData: any = {};
  searchData = { patentNo: "", agencyName: "", applicant: "", inventor: "", auto_applicant: "", auto_inventor: "", auto_agencyName: "" };

  showInputDialog: boolean = false;

  inputMode: string = "";

  @Inject()
  isSuperUser!: () => boolean;

  get validateRules() {
    return {
      "patentNo": { required: true, message: "请输入专利号", trigger: "blur" },
      "applicant": {
        validator: (rule: any, value: string, callback: Function) => {
          if (isEmpty(this.searchData.inventor) && isEmpty(this.searchData.applicant)) {
            callback(new Error("请输入申请人/发明人"));
          } else {
            callback();
          }
        },
        trigger: "blur"
      },
      "inventor": {
        validator: (rule: any, value: string, callback: Function) => {
          if (isEmpty(this.searchData.inventor) && isEmpty(this.searchData.applicant)) {
            callback(new Error("请输入申请人/发明人"));
          } else {
            callback();
          }
        },
        trigger: "blur"
      },
      "agencyName": { required: true, message: "请输入代理机构", trigger: "blur" }
    };
  }

  get dataApi() {
    return API_PATENT_MANUALQUERY;
  }

  showPatentNoDialog(mode: string) {
    this.inputMode = mode;
    this.showInputDialog = true;
  }

  createTableColumns() {
    const patentType = this.$store.getters["enums/getEnumsByKey"]("PatentType");
    let map1: { [key: string]: any } = {};
    if (patentType && patentType.length) {
      patentType.forEach((data: any) => map1[data.enumValue] = data.label);
    }
    const patentStatus = this.$store.getters["enums/getEnumsByKey"]("PatentStatus");
    let map2: { [key: string]: any } = {};
    if (patentStatus && patentStatus.length) {
      patentStatus.forEach((data: any) => map2[data.enumValue] = data.label);
    }
    const columns: Array<TableColumnOption> = [
      { prop: "patentNo", display: "专利号", width: 200, sortable: false },
      {
        prop: "patentType",
        display: "专利类型",
        width: 200,
        formatter: (data: any, column: any, value: any) => {
          return `<div class="patent_type ${value} ">${map1[value]}</div>`;
        },
        sortable: false
      },
      { prop: "title", display: "专利名称", width: 200, sortable: false },
      { prop: "appDate", display: "申请日", width: 200, sortable: false },
      { prop: "pubNo", display: "公开(公告)号", width: 200, sortable: false },
      { prop: "pubDate", display: "公开(公告)日", width: 200, sortable: false },
      { prop: "applicants", display: "申请人", width: 200, sortable: false },
      { prop: "applicantAddress", display: "申请人地址", width: 200, sortable: false },
      { prop: "inventors", display: "发明人", width: 200, sortable: false },
      { prop: "agencyName", display: "代理机构", width: 200, sortable: false },
      { prop: "agentName", display: "代理人", width: 200, sortable: false },
      {
        prop: "patentStatus",
        display: "法律状态",
        width: 200,
        formatter: (data: any, column: any, value: any) => {
          return `${map2[value]}`;
        },
        sortable: false
      },
      { prop: "legalStatus", display: "法律状态", width: 200, sortable: false },
    ];
    this.$store.dispatch("addpatent/setColumns", columns);
  }

  @Watch("showInputDialog")
  clearData() {
    if (!this.showInputDialog) {
      this.searchData.patentNo = "";
      this.searchData.applicant = "";
      this.searchData.inventor = "";
      this.searchData.agencyName = "";
      this.searchData.auto_agencyName = "";
      this.searchData.auto_applicant = "";
      this.searchData.auto_inventor = "";
    }
  }

  loadDialogData() {
    if (this.inputMode === "auto") {
      this.$store.dispatch("addpatent/get", { api: `${API_PATENT_PATENTEE_SETTING}?_=${Math.random().toString().replace(/\D/g, "")}` }).then(data => {
        if (isEmpty(data)) {
          return;
        }
        data = JSON.parse(data);
        Object.keys(data).forEach(item => (this.searchData as any)[`auto_${item}`] = data[item]);
      });
    }
  }

  submitPatentNo() {
    const form = this.$refs.addDataForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      const params = { patentNo: this.searchData.patentNo };
      this.queryStr = JSON.stringify(params);
      this.showGrid = true;
      this.showInputDialog = false;
    });
  }

  submitInv() {
    const form = this.$refs.addDataForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      const params: { [key: string]: any } = {};
      if (!isEmpty(this.searchData.inventor)) {
        params["inventor"] = this.searchData.inventor;
      }
      if (!isEmpty(this.searchData.applicant)) {
        params["applicant"] = this.searchData.applicant;
      }
      this.queryStr = JSON.stringify(params);
      this.showGrid = true;
      this.showInputDialog = false;
    });
  }

  submitAgency() {
    const form = this.$refs.addDataForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      const params: { [key: string]: any } = { agencyName: this.searchData.agencyName };
      this.queryStr = JSON.stringify(params);
      this.showGrid = true;
      this.showInputDialog = false;
    });
  }

  submitAuto() {
    const params = {
      applicant: this.searchData.auto_applicant,
      inventor: this.searchData.auto_inventor,
      agencyName: this.searchData.auto_agencyName
    };
    return this.$store.dispatch("addpatent/post", { api: API_PATENT_PATENTEE_SETTING, params: { expression: JSON.stringify(params) } })
      .then(() => showSuccess("保存成功"))
      .then(() => this.showInputDialog = false)
      .catch(({ message }) => showError(message));
  }

  addPatent() {
    const selectedRows = (this.$refs.patentgrid as any).getSelectedRows();
    const params: { [key: string]: any } = { addByNo: true, patentNo: selectedRows.join() };
    this.$store.dispatch("addpatent/post", { api: API_PATENT_MANUALADD, params }).then((taskId: string) => {
      showSuccess("添加中...，请在顶部查看添加进度");
      this.$store.dispatch("patentsync/setTaskId", taskId);
      this.showGrid = false;
    });
  }

  addAllPatent() {
    const params: { [key: string]: any } = {};
    if (!isEmpty(this.queryStr)) {
      Object.assign(params, JSON.parse(this.queryStr));
    }
    Object.assign(params, { addByNo: false });
    this.$store.dispatch("addpatent/post", { api: API_PATENT_MANUALADD, params }).then((taskId: string) => {
      showSuccess("添加中...，请在顶部查看添加进度");
      this.$store.dispatch("patentsync/setTaskId", taskId);
      this.showGrid = false;
    });
  }

  onSelectedChanged(selectedRows: Array<string>) {
    this.selectedCount = selectedRows.length;
  }

  getTitle() {
    let title = "";
    switch (this.inputMode) {
      case "patentNo":
        title = "请输入专利号";
        break;
      case "inv":
        title = "请输入发明人/申请人";
        break;
      case "office":
        title = "请输入代理机构";
        break;
      case "auto":
        title = "请输入检索式";
        break;
      default:
        title = "";
        break;
    }

    return title;
  }

  backNext() {
    if (this.showGrid) {
      this.showGrid = false;
    } else {
      this.$router.push({ name: "monitor" });
    }
  }
}
